import { Delete, Edit, MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { translate } from '@/ui/i18n';

export function ActionMenuForTourSequence({
  onClickEdit,
  onClickDelete,
}: {
  onClickEdit: () => void;
  onClickDelete: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onClickEditItem = () => {
    onClose();
    onClickEdit();
  };

  const onClickDeleteItem = () => {
    onClose();
    onClickDelete();
  };

  return (
    <>
      <IconButton onClick={onClick}>
        <MoreVert />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
        <MenuItem onClick={onClickEditItem}>
          <Edit sx={{ mr: 1 }} />
          {translate('Form.edit')}
        </MenuItem>
        <MenuItem onClick={onClickDeleteItem}>
          <Delete sx={{ mr: 1 }} />
          {translate('Form.delete')}
        </MenuItem>
      </Menu>
    </>
  );
}
